import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if you needed
import Crud from '../crud'
const model = (payload) => ({
  id: payload.id,
  name: payload.name,
  concept_code: payload.concept_code,
  warehouse_name: payload.warehouse_name
})
var crud = new Crud('Branches', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  branches: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  branches: state => state.branches
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
